import { negate } from 'lodash-es'

import { getCoreAssetType, ProductConfig } from '../state/configuration'
import { CoverOption } from './types'

export const isAddOn = (product: ProductConfig) => negate(isAuxiliary(product))
export const isAuxiliary = (product: ProductConfig) => (coverOption: CoverOption) => {
  const assetType = getCoreAssetType(product)
  return Boolean(
    assetType.covers.optional?.find((it) => it.code === coverOption.coverGroup)?.inputs,
  )
}

export const getUpdatedPriceOptions = (coverOption: CoverOption) =>
  coverOption.priceOptions.map((po) => ({
    ...po,
    active: coverOption.active,
  }))
